import { useMutation } from "@tanstack/react-query";
import { sendPostMessage } from "../actions/sendMessage.actions";

export const useMessagesMutation = () => {
  const messagesMutation = useMutation({
    mutationFn: (messageData) => sendPostMessage(messageData),
    onError: (error) => {
      console.error("[MESSAGE] Failed to send:", error?.response?.data ?? error?.message ?? error);
    },
  });

  return { messagesMutation };
};
